<template>
    <div class="alt-player-label">
        <div class="player">
            <span class="menu-wrapper" @click="togglePlayerMenu" v-if="renderMenu">
                <fa-icon class="player-menu-icon" icon="caret-down" />
                <div class="player-menu" v-if="showPlayerMenu" @click="showBlockUserModal">
                    Block user
                </div>
            </span>
            <royal-coin
                v-if="player.team"
                :color="player.team.color"
                :theme="theme"
            />
            <router-link :to="`/matches/${encodeLabel(player.user.username)}`" class="link" target="_blank">
                <span class="player-name">{{ player.user.username }}</span>
                <span class="player-rank">
                    <rank :skillRating="player.user.skillRating" />
                </span>
            </router-link>
            <disqualified-alert type="icon" v-if="player.user.disqualified" />
        </div>
    </div>
</template>

<script>

export default {
    props: ['player', 'renderMenu', 'theme'],
    name: 'AltPlayerLabel',
    data() {
        return {
            showPlayerMenu: false,
        };
    },
    methods: {
        togglePlayerMenu() {
            this.showPlayerMenu = !this.showPlayerMenu;
        },
        showBlockUserModal() {
            this.$store.dispatch('openModal', {
                type: 'blockUser',
                data: {
                    blockedUserId: this.player.user.id,
                },
            });
        },
        encodeLabel(label) {
            return encodeURIComponent(label);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .alt-player-label {

        .player {
            display: flex;
            justify-content: center;

            > * {
                margin: 0 2.5px;
                align-self: center;
            }

            .link {
                color: $gray;
                display: flex;

                > * {
                    align-self: center;
                }

                .player-name {
                    white-space: nowrap;
                }

                .player-rank {
                    margin-left: 4px;
                }
            }
        }

        .royal-coin {
            height: auto;
            max-height: 16px;
            max-width: 16px;
            width: auto;
            vertical-align: middle;
        }

        .menu-wrapper {
            cursor: pointer;
            padding: 0 2px 0 5px;
            position: relative;
            user-select: none;

            .player-menu-icon {
                font-size: .75rem;
                margin-top: -2px;
                vertical-align: middle;
            }

            .player-menu {
                background: white;
                border-radius: 4px;
                border: 1px solid $light-gray;
                box-shadow: -1px 1px 2px -1px $gray;
                color: $dark-gray;
                cursor: pointer;
                font-size: .85rem;
                padding: 3px 4px;
                position: absolute;
                right: 0;
                bottom: -5px;
                transform: translateY(85%);
                white-space: nowrap;
                z-index: 100;
            }
        }
    }
</style>
